export class FileInfo {
  documentUrl: string;
  libraryDocumentId: string;
  libraryDocumentName: string;
  transientDocumentId: string;

  constructor(info?: any) {
    info = info || {};
    this.documentUrl = info.documentUrl || null;
    this.libraryDocumentId = info.libraryDocumentId || null;
    this.libraryDocumentName = info.libraryDocumentName || null;
    this.transientDocumentId = info.transientDocumentId || null;
  }
}
